import { useSelector } from '../context';
import { selectDesktopContext } from '../slices/desktop/selectors';

export function useDesktop() {
  return {
    isDesktopContext: useSelector(selectDesktopContext),
  };
}
